import _ from 'lodash'

// Helper to create base column state for all presets
/* eslint-disable prettier/prettier */
// prettier-ignore
const createBaseColState = () => [
  // pinned essentials
  { colId: 'selection', width: 40, hide: false, pinned: true, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'title', width: 300, hide: false, pinned: true, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: 1 },

  // story classification
  { colId: 'story_approved', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'story_type', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'status', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'source', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'story_tags', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: 1 },
  { colId: 'is_highlight', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },

  // scheduling
  { colId: 'story_date', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'story_time', width: 85, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'end_date', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'end_time', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },

  // content
  { colId: 'summary', width: 300, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: 1 },
  { colId: 'logistics', width: 300, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'location', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'live_source', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'live_type', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },

  // people & assignments
  { colId: 'assignments', width: 300, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: 1 },
  { colId: 'assignees', width: 300, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'reporter.name', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'videographer.name', width: 200, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'manager.name', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'producer.name', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'editor.name', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'created_by.name', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },

  // media
  { colId: 'counts', width: 236, hide: false, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'share_count', width: 50, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'video_count', width: 70, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'trt', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },

  // system / record metadata
  { colId: 'id', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'parent_id', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'station', width: 110, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'created_at', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'updated_at', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'last_activity_at', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null },
  { colId: 'deleted_at', width: 200, hide: true, pinned: null, sort: null, sortIndex: null, aggFunc: null, rowGroup: false, rowGroupIndex: null, pivot: false, pivotIndex: null, flex: null }
]
/* eslint-enable prettier/prettier */

// Helper to customize column state for specific presets
const customizeColState = (baseState, customizations) => {
  const state = _.cloneDeep(baseState)
  customizations.forEach(({ colId, ...props }) => {
    const col = state.find((c) => c.colId === colId)
    if (col) {
      Object.assign(col, props)
    }
  })
  return state
}

// Create preset templates
export const byDaypartTemplate = {
  name: 'By Daypart',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'story_type', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'status', sort: 'asc', sortIndex: 2, hide: false }
  ])
}

export const byStatusTemplate = {
  name: 'By Status',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'status', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'reporter.name', hide: false }
  ])
}

export const bySourceTemplate = {
  name: 'By Source',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'source', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'status', sort: 'asc', sortIndex: 2, hide: false },
    { colId: 'reporter.name', hide: false }
  ])
}

export const byCreatedTemplate = {
  name: 'By Created',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'created_by.name', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'source', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'status', sort: 'asc', sortIndex: 2, hide: false }
  ])
}

export const byReporterTemplate = {
  name: 'By Reporter',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'reporter.name', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'status', hide: false }
  ])
}

export const byTagsTemplate = {
  name: 'By Tags Grouped',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  colState: customizeColState(createBaseColState(), [
    { colId: 'story_tags', rowGroup: true, rowGroupIndex: 0, sort: 'asc', sortIndex: 0, hide: false },
    { colId: 'story_time', sort: 'asc', sortIndex: 1, hide: false },
    { colId: 'story_type', sort: 'asc', sortIndex: 2, hide: false },
    { colId: 'source', sort: 'asc', sortIndex: 3, hide: false },
    { colId: 'status', sort: 'asc', sortIndex: 4, hide: false }
  ])
}

export const byLatestUpdatesTemplate = {
  name: 'Latest Updates',
  saveOptions: ['columns', 'filter', 'sort'],
  filterState: [],
  quickFilter: null,
  // Sorts on last_activity_at, not updated_at: updated_at only moves when the story
  // row itself is written, so comments, tasks, scripts and media never floated a
  // story here (ND-2306). updated_at stays visible alongside it for reference.
  colState: customizeColState(createBaseColState(), [
    { colId: 'last_activity_at', sort: 'desc', sortIndex: 0, hide: false, width: 160 },
    { colId: 'updated_at', hide: false, width: 140 },
    { colId: 'created_at', hide: false, width: 140 },
    { colId: 'story_date', hide: false, width: 120 },
    { colId: 'assignments', hide: true },
    { colId: 'assignees', hide: true },
    { colId: 'reporter.name', hide: true },
    { colId: 'videographer.name', hide: true },
    { colId: 'story_type', hide: true },
    { colId: 'story_approved', hide: true },
    { colId: 'source', hide: true }
  ])
}

export const starterPackTemplates = [
  byDaypartTemplate,
  byStatusTemplate,
  bySourceTemplate,
  byCreatedTemplate,
  byReporterTemplate,
  byTagsTemplate,
  byLatestUpdatesTemplate
]
